import { renderInDocument } from '@spotahome/soyuz/client';

import SearchPage from './search';

renderInDocument(SearchPage);
